import { useRef, useState } from "react";
import { Button, Flex } from "@radix-ui/themes";
import {
  MixerHorizontalIcon,
  ReloadIcon,
  GearIcon,
} from "@radix-ui/react-icons";

import { RelativeDrawer } from "@/components/relative-drawer";
import Tooltip from "@/components/shared/tooltip/Tooltip";

import styles from "./styles.module.scss";
import { useKnowledgeHubConfiguration } from "./api";
import { KnowledgeHubDrawer } from "./parts/drawer";
import { ConfigurationDrawer } from "./parts/drawer/ConfigurationDrawer";
// import { EmbedDialog } from "./parts/embedDialog";
import { KnowledgeHub as KnowledgeHubComponent } from "./parts/core/features/wrapper/useKnowledgeHub";

export const KnowledgeHub = () => {
  const [activeDrawer, setActiveDrawer] = useState<
    "customization" | "configuration" | null
  >(null);
  const activeDrawerPublishRef = useRef<(() => boolean | void) | null>(null);
  const [restartKey, setRestartKey] = useState(0);

  const {
    configuration: knowledgeHubConfiguration,
    updateConfiguration,
    token,
  } = useKnowledgeHubConfiguration();

  return (
    <div className={styles.container}>
      <div className={styles.controlRow}>
        <Flex gap="2">
          <Tooltip>
            <Tooltip.Trigger>
              <Button
                color="gray"
                variant="outline"
                highContrast
                size="1"
                onClick={() => setRestartKey((prev) => prev + 1)}
              >
                <ReloadIcon style={{ width: 12, height: 12 }} />
              </Button>
            </Tooltip.Trigger>
            <Tooltip.Content>
              <span style={{ fontSize: "12px" }}>Force Widget Restart</span>
            </Tooltip.Content>
          </Tooltip>
          <Button
            key="configurations"
            color="gray"
            variant="outline"
            highContrast
            size="1"
            onClick={() =>
              setActiveDrawer((prev) =>
                prev === "configuration" ? null : "configuration"
              )
            }
          >
            <GearIcon />
            Configurations
          </Button>
          <Button
            key="customize"
            color="gray"
            variant="outline"
            highContrast
            size="1"
            onClick={() =>
              setActiveDrawer((prev) =>
                prev === "customization" ? null : "customization"
              )
            }
          >
            <MixerHorizontalIcon />
            Customize
          </Button>

          {activeDrawer && (
            <Button
              key="publish"
              color="gray"
              highContrast
              size="1"
              variant="solid"
              onClick={() => {
                const success = activeDrawerPublishRef.current?.() ?? true;
                if (success !== false) {
                  setActiveDrawer(null);
                }
              }}
            >
              Publish
            </Button>
          )}

          {/* TODO: Add embed dialog */}
          {/* <Popover.Root key="embed">
            <Popover.Trigger>
              <Button
                key="embed"
                color="gray"
                highContrast
                size="1"
                onClick={() => {}}
              >
                <CodeIcon />
                Embed
              </Button>
            </Popover.Trigger>
            <Popover.Content>
              <EmbedDialog token={token} />
            </Popover.Content>
          </Popover.Root> */}
        </Flex>
      </div>
      <div className={styles.main}>
        <RelativeDrawer
          side="right"
          width={380}
          drawer={
            knowledgeHubConfiguration && (
              <>
                {activeDrawer === "customization" && (
                  <KnowledgeHubDrawer
                    config={knowledgeHubConfiguration}
                    updateConfiguration={updateConfiguration}
                    publishActionRef={activeDrawerPublishRef}
                  />
                )}
                {activeDrawer === "configuration" && (
                  <ConfigurationDrawer
                    config={knowledgeHubConfiguration}
                    updateConfiguration={updateConfiguration}
                    publishActionRef={activeDrawerPublishRef}
                  />
                )}
              </>
            )
          }
          isOpen={knowledgeHubConfiguration != null && activeDrawer !== null}
          onOpenChange={(open) => !open && setActiveDrawer(null)}
        >
          <KnowledgeHubComponent
            key={restartKey}
            config={knowledgeHubConfiguration}
            loadingConfig={!knowledgeHubConfiguration}
            configurationToken={token}
          />
        </RelativeDrawer>
      </div>
    </div>
  );
};
